import { useState } from 'react';
import useEventsTracker from '../../tracking/useEventsTracker';
import useRecentFilterSetsHandler from '../FilterSetsList.js/useRecentFilterSetsHandler';
import useContextActions from '../../../../useContextActions';

const useFormSaveHandler = ({
  formState,
  Context,
  onSubmit,
  formValidator
}) => {
  const contextActions = useContextActions({ Context });
  const [isLoading, setIsLoading] = useState(false);
  const eventsTracker = useEventsTracker({ Context });
  const { updateRecentFilterSetIds } = useRecentFilterSetsHandler(Context);

  const updateFilterSet = async () =>
    await contextActions.onUpdateFilterSet(formState.id, formState);

  const createFilterSet = async () => {
    const newFilterSet = await contextActions.onCreateFilterSet(formState);
    updateRecentFilterSetIds(newFilterSet?.id);
  };

  const submit = async () => {
    setIsLoading(true);

    const isEditMode = Boolean(formState?.id);
    const validationError = formValidator.validate();
    try {
      if (!!validationError) {
        throw new Error(validationError.message);
      }
      await (isEditMode ? updateFilterSet() : createFilterSet());
      onSubmit?.();
      eventsTracker.onUpsertFilterSet(formState);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  return { submit, isLoading };
};

export default useFormSaveHandler;
